module.exports = __webpack_public_path__ + "media/images/icons/002__arrow_right-ce35a12205e436b11738c16be0cfbfb4.svg";